"use client";

import { BookOpen01Icon } from "@hugeicons-pro/core-stroke-rounded";
import ControlIcon from "./ControlIcon";
import { ControlContainer, type ControlProps } from "./IconContainer";

export function GameControlsRules(props: ControlProps) {
  return (
    <ControlContainer {...props}>
      <ControlIcon icon={BookOpen01Icon} />
    </ControlContainer>
  );
}
